<template>
  <div class="profile">
     <h1> Parent Settings </h1>
     <MailSettings></MailSettings>
   </div>

</template>

<script>

// import firebase from 'firebase/app'
import {mapState} from 'vuex'
import MailSettings from './profile/MailSettingsCard'

export default {
  name: 'Profile',
  components: {
    MailSettings
  },
  computed: {
    ...mapState({
    })
  },
  props: {

  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
